<template>
    <el-card class="reportsList">
        <div style=" font-size: 16px;
        font-weight: 900;">服务台</div>
        <ul>
            <router-link :to="{path:'/greatEventList'}">
                <li>重大事件统计</li>
            </router-link>
            <router-link :to="{path:'/closeEvent'}">
                <li>事件是否及时关闭及满意度调查统计</li>
            </router-link>
            <router-link :to="{path:'/eventType'}">
                <li>事件生成类型统计</li>
            </router-link>
            <router-link :to="{path:'/acceptComplete'}">
                <li>服务台受理与直接处理完成事件统计</li>
            </router-link>
            <router-link :to="{path:'/eventComplete'}">
                <li>事件完成统计</li>
            </router-link>
            <router-link :to="{path:'/eventOutTime',query:{type:'day'}}">
                <li>事件超时响应统计(按天)</li>
            </router-link>
            <router-link :to="{path:'/eventOutTime'}">
                <li>事件超时响应统计(按月)</li>
            </router-link>
            <router-link :to="{path:'/undistributedWork'}">
                <li>未分配工单数(按天)</li>
            </router-link>
            <router-link :to="{path:'/workEfficiency'}">
                <li>工作效率统计</li>
            </router-link>



        </ul>
    </el-card>
</template>

<script>
    export default {

    }
</script>

<style scoped>
    .reportsList{
        /*height: 120px;*/
        background: white;
        font-size: 15px;
    }
    .reportsList div{
        padding-left: 15px;
    }
    .reportsList ul{
        float: left;
        margin: 20px 10px 10px 10px;

    }
    .reportsList ul li{
        color: grey;
        float: left;
        margin: 5px 35px 5px 5px;
    }
</style>
